import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { useRef } from "react";
import { Reveal, Eyebrow } from "./primitives";

const ABOUT_IMG =
    "https://images.unsplash.com/photo-1569258592171-357ea26da4df?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function About() {
    const ref = useRef(null);
    const reduce = useReducedMotion();
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

    return (
        <section id="about" ref={ref} data-testid="about-section" className="border-b border-navy-line">
            <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-14 px-5 py-24 sm:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:py-32">
                <div className="relative">
                    <Reveal>
                        <div className="clip-tag relative overflow-hidden border border-navy-line">
                            <motion.img
                                src={ABOUT_IMG}
                                alt="Monumental concrete infrastructure architecture"
                                style={reduce ? undefined : { y, scale: 1.15 }}
                                className="h-[420px] w-full object-cover lg:h-[560px]"
                            />
                        </div>
                    </Reveal>
                    <Reveal delay={0.15} className="absolute -right-2 -top-6 hidden lg:block">
                        <div className="border border-navy bg-paper px-6 py-4">
                            <p className="font-display text-4xl font-bold text-navy">Jodhpur</p>
                            <p className="text-[11px] font-semibold uppercase tracking-wide2 text-ink/50">
                                Rajasthan, India
                            </p>
                        </div>
                    </Reveal>
                </div>

                <div className="flex flex-col justify-center">
                    <Reveal>
                        <Eyebrow>Who We Are</Eyebrow>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="mt-6 font-display text-5xl font-semibold uppercase leading-[0.95] tracking-mega text-navy md:text-6xl">
                            Built on
                            <br />
                            <span className="text-orange">ground truth.</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <p className="mt-8 max-w-xl text-base leading-relaxed text-ink/70 md:text-lg">
                            Pawan Putra Infra is a railway civil works contractor headquartered in
                            Jodhpur, Rajasthan. We take on the demanding end of infrastructure —
                            railway track works, platform and station construction, bridges,
                            earthwork and general civil infrastructure — where precision of line,
                            level and schedule decides the project.
                        </p>
                    </Reveal>
                    <Reveal delay={0.3}>
                        <p className="mt-5 max-w-xl text-base leading-relaxed text-ink/70">
                            Every site we run is treated like an engineering document: measured,
                            checked and recorded. That discipline is what railway authorities,
                            public agencies and private developers hire us for.
                        </p>
                    </Reveal>
                    <Reveal delay={0.4}>
                        <div className="mt-10 grid grid-cols-1 gap-px border border-navy-line bg-navy-line sm:grid-cols-3">
                            {[
                                ["Railway", "Civil works"],
                                ["Jodhpur", "Head office"],
                                ["Pan-India", "Execution reach"],
                            ].map(([big, small]) => (
                                <div key={big} className="bg-paper px-6 py-5">
                                    <p className="font-display text-xl font-semibold uppercase text-navy">{big}</p>
                                    <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide2 text-ink/50">
                                        {small}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
